/**
 * Random Code Generator — shared utility for generating random alphanumeric codes.
 *
 * Used by both link codes (auth.ts) and join codes (classrooms.ts).
 * Uses an unambiguous character set (no 0/O/1/I/L confusion).
 *
 * Extracted from auth.ts generateLinkCode() and classrooms.ts generateJoinCode() (D-SCAN-2 D2-2).
 */

/** Unambiguous alphanumeric characters (no 0/O, 1/I/L) */
export const UNAMBIGUOUS_CHARSET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'

/**
 * Generate a random code of the given length using the unambiguous charset.
 * Uses Math.random() — NOT cryptographically secure.
 *
 * // FASE3: Replace with crypto.getRandomValues() for server-side code generation.
 */
export function generateRandomCode(
  length: number = 6,
  charset: string = UNAMBIGUOUS_CHARSET,
): string {
  let code = ''
  for (let i = 0; i < length; i++) {
    code += charset.charAt(Math.floor(Math.random() * charset.length))
  }
  return code
}
